import * as _ from 'lodash'
// import { getAbbreviation } from '../../helpers/state-abbreviation'
export default {
	name: 'thankyou',
	created () {
	
	},
	mounted () {
		// console.log('im here', this.$store.getters.selectedAreas)
		// this.abbr = getAbbreviation()
		// console.log(this.abbr)
		this.initData()
	},
	data () {
		return {
			// polygons : {},
			// excludedAreas: [],
			// selectedAreas: [],
			// abbr: {},
			company: null,
		}
	},
	methods: {
		initData(){
			this.company = this.$store.getters.company;
			// this.selectedAreas = _.groupBy(this.$store.getters.selectedAreas,function(area){ return area.state })
			// let context = this;
			// _.forEach(context.selectedAreas,function (area,index) {
			// 	context.selectedAreas[index] = _.map(area,"area_code")
			// })

			// this.excludedAreas = this.$store.getters.excludedAreas
			// console.log(this.excludedAreas)
		}
	}
}


// WEBPACK FOOTER //
// ./src/pages/Thankyou/thankyou.script.js